import State from '../core/State';
import CreativeIndexForDirectorWeb from '../entity/CreativeForDirectorWeb';

/**
 * 事例検索APIのfetch開始
 */
export const startFetchAdVideo = () => (state: State): State => ({
  ...state,
  adSearch: {
    ...state.adSearch,
    isLoading: true,
    isLoaded: false,
    error: null,
  },
});

/**
 * 事例検索APIのfetch成功
 */
export const successFetchAdVideo = (data: CreativeIndexForDirectorWeb) => (state: State): State => ({
  ...state,
  adSearch: {
    ...state.adSearch,
    isLoading: false,
    isLoaded: true,
    data,
    error: null,
  },
});

/**
 * 事例検索APIのfetch失敗
 */
export const failFetchAdVideo = (err: any) => (state: State): State => ({
  ...state,
  adSearch: {
    ...state.adSearch,
    isLoading: false,
    isLoaded: true,
    error: err,
  },
});

export const setSelectedVideo = (data: any) => (state: State): State => ({
  ...state,
  adSearch: {
    ...state.adSearch,
    isLoading: false,
    isLoaded: true,
    selectedVideos: data,
  },
});

export const setData = (data: CreativeIndexForDirectorWeb) => (state: State): State => ({
  ...state,
  adSearch: {
    ...state.adSearch,
    data,
  },
});
